export default "__VITE_ASSET__DGUVK1UI__"